import { getContextAttributeValue } from '../attributes/getContextAttributeValue';
import { getContextKey } from '../kind-key/getContextKey';
import type { LDContext } from '../types/types';

type DisplayableUser = {
  key?: string;
  email?: string;
  name?: string;
  firstName?: string;
  lastName?: string;
};

function getDisplayName(user: DisplayableUser): string {
  if (user.name) {
    return user.name;
  }
  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }
  if (user.email) {
    return user.email;
  }
  return user.key || '';
}

/**
 * Get a formatted display name from a context.
 * Tries name, then firstName+lastName, then email, then key.
 *
 * @param context - The context to get the display name from.
 * @returns The formatted display name.
 */
export function getContextDisplayName(context: LDContext): string {
  const displayableUser: DisplayableUser = {
    key: getContextKey(context),
    email: context?.email,
    name: getContextAttributeValue(context, 'name'),
    firstName: context?.firstName,
    lastName: context?.lastName,
  };
  return getDisplayName(displayableUser);
}
